import React from "react";
import { buildAutomationChildTestId, resolveAutomationTestId } from "../../InputField/testId";

const DateBar = ({
  label,
  value,
  onChange,
  placeholder = "YYYY-MM-DD",
  showClear = true,
  className = "",
  disabled = false,
  required = false,
  testId,
  id,
  "data-testid": dataTestId,
}) => {
  const fieldTestId = resolveAutomationTestId(dataTestId, testId, id);

  return (
    <div className={`account-search-date ${className}`.trim()} data-testid={fieldTestId}>
      {label ? <div className="account-search-dropdown__label">{label}</div> : null}
      <div className="account-search-date__control">
        <input
          className="account-search-input__control account-search-date__input"
          type="date"
          value={value || ""}
          onChange={(event) => onChange?.(event.target.value)}
          placeholder={placeholder}
          disabled={disabled}
          required={required}
          aria-required={required}
          data-testid={buildAutomationChildTestId(fieldTestId, "input")}
        />
        {showClear && value ? (
          <button
            type="button"
            className="account-search-date__clear"
            onClick={() => onChange?.("")}
            disabled={disabled}
            aria-label={`Clear ${label || "date"}`}
            data-testid={buildAutomationChildTestId(fieldTestId, "clear")}
          >
            x
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default DateBar;
